// extracted by mini-css-extract-plugin
export default {"image":"P2-z","loaded":"Q2-z"};